/* eslint-disable jsx-a11y/anchor-is-valid */
import { createContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DownloadListing } from "../../modules/download/component/Download";
import { Setting } from "../../modules/setting/component/Setting";
import { AddBank } from "../../modules/setting/component/bankMangement/AddBank";
import { Bonus } from "../../modules/setting/component/bonus/Bonus";
import { ContactUs } from "../../modules/setting/component/contactUs/contactUs";
import { Deposit } from "../../modules/setting/component/deposit/deposit";
import { MobileDeposit } from "../../modules/setting/component/deposit/depositDialog/gatewayDeposit/mobileDeposit/MobileDeposit";
import { GameTransfer } from "../../modules/setting/component/gameTransfer/GameTransfer";
import { Group } from "../../modules/setting/component/group/Group";
import { LiveChat } from "../../modules/setting/component/liveChat/LiveChat";
import { MemberTransfer } from "../../modules/setting/component/memberTransfer/MemberTransfer";
import { Personal } from "../../modules/setting/component/personal/Personal";
import { PointShop } from "../../modules/setting/component/pointShop/PointShop";
import { Team } from "../../modules/setting/component/team/Team";
import { Vip } from "../../modules/setting/component/vip/Vip";
import { Withdraw } from "../../modules/setting/component/withdraw/Withdraw";
const SettingContext = createContext();

const SettingWrapper = ({}) => {
  const value = {};

  return (
    <SettingContext.Provider value={value}>
      <Routes>
        <Route path="/profile" element={<Setting />} />
        <Route path="/deposit" element={<Deposit />} />
        <Route path="/deposit/payment" element={<MobileDeposit />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="/pointShop" element={<PointShop />} />
        <Route path="/bonus" element={<Bonus />} />
        <Route path="/memberTransfer" element={<MemberTransfer />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/transfer" element={<GameTransfer />} />
        <Route path="/addBank" element={<AddBank />} />
        <Route path="/chat" element={<LiveChat />} />
        <Route path="/download" element={<DownloadListing />} />
        <Route path="/team" element={<Team />} />
        <Route path="/group" element={<Group />} />
        <Route path="/vip" element={<Vip />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/*" element={<Navigate to="/profile" />} />
      </Routes>
    </SettingContext.Provider>
  );
};

export { SettingWrapper };
